import styled from 'styled-components';
import NativeLink from '../../common/NativeLink';

const BridgecrestInformationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    margin-bottom: 0px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-bottom: 0px;
  }
`;

const BridgecrestPartnershipWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0px 0px 5px 0px;
`;

const BridgecrestPartnershipLabel = styled.h4`
  color: ${(props) => props.theme.color.neutral.v500};
  font-weight: normal;
  font-size: 14px;
  display: flex;
  line-height: 45px;
  height: 30px;
`;

const BridgecrestPartnershipLogo = styled.img`
  width: 103px;
  height: 37px;
  display: flex;
`;

const BridgecrestContactInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    margin-bottom: 0px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-bottom: 0px;
  }
`;

const BridgecrestContactInfo = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    margin-bottom: 0px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-bottom: 0px;
    min-width: 160px;
  }

  @media (max-width: 374px) {
    min-width: auto;
  }
`;

const BridgecrestContactInfoQuestion = styled.h3`
  color: ${(props) => props.theme.color.primary.v600};
  ${(props) => props.theme.font.label.v300};
  line-height: 24px;

  cursor: inherit;
  margin: 0 0 4px 0;
  align-items: center;
  // overriding styled component styling
  &&& {
    font-size: 16px;
    line-height: 24px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    ${(props) => props.theme.font.body.v300};
  }
`;

const BridgecrestContactInfoAnswer = styled.p`
  color: ${(props) => props.theme.color.neutral.v500};
  ${(props) => props.theme.font.body.v200};
  margin: 0;
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    ${(props) => props.theme.font.body.v300};
  }
  &&& {
    font-size: 14px;
    line-height: 20px;
  }
`;

const BridgecrestHyperLink = styled(NativeLink)`
  color: ${(props) => props.theme.color.primary.v200};
  text-decoration: underline;
`;

const BridgecrestUrl = styled(NativeLink)`
  color: ${(props) => props.theme.color.primary.v200};
  padding: 0 5px;
  text-decoration: underline;
`;

const BridgecrestLogo = styled.img`
  margin: 0 0 2px 2px;
`;

export {
  BridgecrestInformationWrapper,
  BridgecrestPartnershipWrapper,
  BridgecrestPartnershipLabel,
  BridgecrestPartnershipLogo,
  BridgecrestContactInfoWrapper,
  BridgecrestContactInfo,
  BridgecrestContactInfoQuestion,
  BridgecrestContactInfoAnswer,
  BridgecrestHyperLink,
  BridgecrestUrl,
  BridgecrestLogo,
};
